import { CALL_API } from '../../middleware/api';
const queryString = require('query-string');

/**
 * 目标添加
 */
export const OBJECTIVE_ADD_REQUEST = 'OBJECTIVE_ADD_REQUEST';
export const OBJECTIVE_ADD_SUCCESS = 'OBJECTIVE_ADD_SUCCESS';
export const OBJECTIVE_ADD_FAILURE = 'OBJECTIVE_ADD_FAILURE';

/**
 * 目标更新
 */
export const OBJECTIVE_UPDATE_REQUEST = 'OBJECTIVE_UPDATE_REQUEST';
export const OBJECTIVE_UPDATE_SUCCESS = 'OBJECTIVE_UPDATE_SUCCESS';
export const OBJECTIVE_UPDATE_FAILURE = 'OBJECTIVE_UPDATE_FAILURE';

/**
 * 目标删除
 */
export const OBJECTIVE_DELETE_REQUEST = 'OBJECTIVE_DELETE_REQUEST';
export const OBJECTIVE_DELETE_SUCCESS = 'OBJECTIVE_DELETE_SUCCESS';
export const OBJECTIVE_DELETE_FAILURE = 'OBJECTIVE_DELETE_FAILURE';

/**
 * 目标概览
 */
export const OBJECTIVE_SUMMARY_REQUEST = 'OBJECTIVE_SUMMARY_REQUEST';
export const OBJECTIVE_SUMMARY_SUCCESS = 'OBJECTIVE_SUMMARY_SUCCESS';
export const OBJECTIVE_SUMMARY_FAILURE = 'OBJECTIVE_SUMMARY_FAILURE';

/**
 * 目标列表
 */
export const OBJECTIVE_LIST_REQUEST = 'OBJECTIVE_LIST_REQUEST';
export const OBJECTIVE_LIST_SUCCESS = 'OBJECTIVE_LIST_SUCCESS';
export const OBJECTIVE_LIST_FAILURE = 'OBJECTIVE_LIST_FAILURE';

/**
 * 获取某个时间轴上所有目标
 */
export const OBJECTIVE_BY_TIME_REQUEST = 'OBJECTIVE_BY_TIME_REQUEST';
export const OBJECTIVE_BY_TIME_SUCCESS = 'OBJECTIVE_BY_TIME_SUCCESS';
export const OBJECTIVE_BY_TIME_FAILURE = 'OBJECTIVE_BY_TIME_FAILURE';

/**
 * 复制目标
 */
export const OBJECTIVE_COPY_REQUEST = 'OBJECTIVE_COPY_REQUEST';
export const OBJECTIVE_COPY_SUCCESS = 'OBJECTIVE_COPY_SUCCESS';
export const OBJECTIVE_COPY_FAILURE = 'OBJECTIVE_COPY_FAILURE';

/**
 * 目标
 */
export const OBJECTIVE_BY_TIMES_REQUEST = 'OBJECTIVE_BY_TIMES_REQUEST';
export const OBJECTIVE_BY_TIMES_SUCCESS = 'OBJECTIVE_BY_TIMES_SUCCESS';
export const OBJECTIVE_BY_TIMES_FAILURE = 'OBJECTIVE_BY_TIMES_FAILURE';

export function addObjective(params) {
  return {
    [CALL_API]: {
      types: [OBJECTIVE_ADD_REQUEST, OBJECTIVE_ADD_SUCCESS, OBJECTIVE_ADD_FAILURE],
      endpoint: 'okr/objective/add',
      methods: 'POST',
      params
    }
  }
}

export function updateObjective(params) {
  return {
    [CALL_API]: {
      types: [OBJECTIVE_UPDATE_REQUEST, OBJECTIVE_UPDATE_SUCCESS, OBJECTIVE_UPDATE_FAILURE],
      endpoint: 'okr/objective/update',
      methods: 'POST',
      params
    }
  }
}

export function deleteObjective(params) {
  return {
    [CALL_API]: {
      types: [OBJECTIVE_DELETE_REQUEST, OBJECTIVE_DELETE_SUCCESS, OBJECTIVE_DELETE_FAILURE],
      endpoint: 'okr/objective/delete',
      methods: 'POST',
      params
    }
  }
}

export function getObjectiveList(params) {
  console.log('getObjectiveList params:::', params);
  return {
    [CALL_API]: {
      types: [OBJECTIVE_LIST_REQUEST, OBJECTIVE_LIST_SUCCESS, OBJECTIVE_LIST_FAILURE],
      endpoint: 'okr/objective/list',
      methods: 'GET',
      params
    }
  }
}

export function getObjectiveSummary(oid) {
  return {
    [CALL_API]: {
      types: [OBJECTIVE_SUMMARY_REQUEST, OBJECTIVE_SUMMARY_SUCCESS, OBJECTIVE_SUMMARY_FAILURE],
      endpoint: 'okr/objective/summary?oid=' + oid,
      methods: 'GET'
    }
  }
}

export function getObjectiveByTime(tid) {
  return {
    [CALL_API]: {
      types: [OBJECTIVE_BY_TIME_REQUEST, OBJECTIVE_BY_TIME_SUCCESS, OBJECTIVE_LIST_FAILURE],
      endpoint: 'okr/objective/all?timeId=' + tid,
      methods: 'GET'
    }
  }
}

export function objectiveCopy(params) {
  return {
    [CALL_API]: {
      types: [OBJECTIVE_COPY_REQUEST, OBJECTIVE_COPY_SUCCESS, OBJECTIVE_COPY_FAILURE],
      endpoint: 'okr/objective/copy',
      methods: 'POST',
      params
    }
  }
}

export function getObjectiveByTimes(params) {
  return {
    [CALL_API]: {
      types: [OBJECTIVE_BY_TIMES_REQUEST, OBJECTIVE_BY_TIMES_SUCCESS, OBJECTIVE_BY_TIMES_FAILURE],
      endpoint: 'okr/objective/get-objective-by-time-ids',
      methods: 'GET',
      params
    }
  }
}




// WEBPACK FOOTER //
// ./src/action/okr_manage/objective.js